import { useHistory } from 'react-router-dom';
import { string, shape, func } from 'prop-types';
import CheckCircleIcon from 'images/pro/greenCheck-filled.svg';
import { StringConstantsMixin, ProPageStrings } from 'react_components/mixins/shared/string_constants_mixin';
import { pushHistory } from 'utils/client_side_routing_helpers';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { FormattedMessage } from 'react-intl';
import Plan from 'types/Plan';
import CurrencyCode from 'types/CurrencyCode';
import PlanType from 'components/GiftFlow/GiftPlan';
import { useGiftFlowContext } from '../../GiftFlow/GiftFlow';
import * as styles from './styles/styles.module.scss';
import BulletList from '../../../shared/text/BulletList';
import Expandable from '../../../shared/Expandable';

type GiftingHeaderProps = {
  planTypes: Plan[];
  currencyCode: CurrencyCode;
};

const {
  strings: {
    GIFT_FLOW: { GIVE_THE_GIFT, FEATURES_DESIGNED_FOR_ALL, BUY_GIFT }
  }
} = StringConstantsMixin;

const FEATURES = ProPageStrings.featuresList.slice(0, 4);

const BulletIcon = () => <img src={CheckCircleIcon} alt="checkmark" className={styles.checkMarkIcon} />;

const GiftingHeader = ({ planTypes, currencyCode = 'USD' }: GiftingHeaderProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const history = useHistory();
  const {
    giftFlowState: { activePlanType }
  } = useGiftFlowContext();

  const handleSubmit = () => {
    pushHistory('/gift/customize', history, languageRegionCode);
  };

  const bulletList = <BulletList classes={styles.bulletList} bullet={<BulletIcon />} list={FEATURES} />;

  return (
    <section className={styles.container}>
      <div className={styles.banner} />
      <div className={styles.featuresAndChoose}>
        <div className={styles.features}>
          <h1 className={styles.featureHeader} data-testid="give_the_gift">
            {GIVE_THE_GIFT}
          </h1>
          <div className={styles.mobileBulletList}>
            <Expandable title={FEATURES_DESIGNED_FOR_ALL} classes={styles.bulletList}>
              {bulletList}
            </Expandable>
          </div>
          <div className={styles.desktopBulletList}>{bulletList}</div>
        </div>
        <div className={styles.planType}>
          <PlanType
            activePlanType={activePlanType}
            buttonText={BUY_GIFT}
            currencyCode={currencyCode}
            handleSubmit={handleSubmit}
            headerText={<FormattedMessage defaultMessage="Pick your gift" />}
            planTypes={planTypes}
          />
        </div>
      </div>
    </section>
  );
};

GiftingHeader.contextTypes = {
  giftFlowState: shape({
    activePlanType: string
  }),
  dispatchGiftFlow: func
};

export default GiftingHeader;
